export const selectRefereeStyles = {
  searchContainer: {
    display: "flex",
    alignItems: "center",

    backgroundColor: "#F0F0F0",
    borderRadius: "10px",
    padding: "0px 12px",
    marginBottom: "13px",
  },
  searchField: {
    border: "none",
    backgroundColor: "transparent",
    width: "100%",
    height: "35px",
    "& .MuiInputBase-root": {
      padding: "0px",
      height: "35px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiInputAdornment-root": {
      margin: "0",
    },
  },
  searchIcon: {
    color: "#A0A0A0",
    // marginTop: "8px",
  },

  searchInput: {
    flex: 1,
    fontSize: "16px",
    fontWeight: "400",
    paddingVertical: "7px",
  },

  scrollContainer: {
    flex: 1,
    marginBottom: "50px",
  },
  card: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    paddingVertical: "6px",
    marginBottom: "8px",
  },
  imageContainer: {
    marginRight: "16px",
  },
  image: {
    width: "80px",
    height: "80px",
    borderRadius: "8px",
  },
  detailsContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "0.5px solid #8D8D8D",
  },
  textContainer: {
    flex: 1,
    paddingVertical: "10px",
  },
  name: {
    fontWeight: "600",
    fontSize: "17px",
    color: "#0D0D0D",
    lineHeight: "25.5px",
    letterSpacing: "0.347px",
    marginBottom: "3px",
  },
  company: {
    fontSize: "15px",
    color: "#000",
    marginBottom: "1px",
    fontWeight: "400",
  },
  location: {
    fontSize: "15px",
    color: "#000",
    fontWeight: "400",
  },
  noInfluencerText: {
    fontSize: "17px",
    color: "#000",
    textAlign: "center",
    marginTop: 10,
    fontWeight: "600",
  },
  plusIconButton: {
    backgroundColor: "#D9D9D9",
    height: "32px",
    width: "44px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "30px",
    cursor: "pointer",
  },
};
